import { Button, ButtonProps } from 'react-bootstrap';
import styled from 'styled-components';

type StyleProps = Partial<{ transparent: boolean }>;
const Root = styled(Button)<StyleProps>`
  padding: 0.375rem 0.4rem;
  border: none !important;
  &:disabled {
    border: none !important;
  }
  &:hover {
    background-color: ${({ $transparent }) => ($transparent ? 'transparent!important' : undefined)};
  }
  background-color: ${({ $transparent }) => ($transparent ? 'transparent!important' : undefined)};
`;

type Props = React.PropsWithChildren<Partial<{ transparent: boolean } & ButtonProps>>;
const LinkBtn = (props: Props) => {
  const { children, className, transparent, ...btnProps } = props;

  return (
    <Root variant="link" $transparent={transparent} {...btnProps}>
      {children}
    </Root>
  );
};

export default LinkBtn;
